import React from 'react';

export type TrendDirection = 'up' | 'down' | 'neutral';

interface StatCardProps {
  label: string;
  value: string;
  sublabel?: string;
  trend?: TrendDirection;
  highlighted?: boolean;
}

export const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  sublabel,
  trend,
  highlighted = false,
}) => {
  return (
    <div className={`border p-4 ${highlighted ? 'bg-gray-100 border-gray-300' : 'bg-gray-50 border-gray-200'}`}>
      <p className="text-sm text-gray-600 mb-1">{label}</p>
      <p className="text-2xl font-bold text-gray-900">
        {value}
        {trend && (
          <span className="ml-2 text-sm text-gray-600">
            {trend === 'up' ? '↑' : trend === 'down' ? '↓' : '→'}
          </span>
        )}
      </p>
      {sublabel && <p className="text-xs text-gray-500 mt-1">{sublabel}</p>}
    </div>
  );
};
